import VueRouter from 'vue-router'
import Vue from 'vue'


export default {
    createRouter: function (routes = []) {
        const DEFAULT_TITLE = process.env.VUE_APP_TITLE

        const router = new VueRouter({
            mode: 'history',
            routes: routes,
            base: process.env.BASE_URL
        })

        const toProperCase = function (value) {
            return value.replace(
                /\w\S*/g,
                function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            )
        }

        router.afterEach((to) => {
            Vue.nextTick(() => {
                if (to.meta.pageTitle) {
                    document.title = to.meta.pageTitle
                } else if (to.meta.title) {
                    document.title = `${toProperCase(to.meta.title.replace('HOME', DEFAULT_TITLE))}`
                } else {
                    document.title = DEFAULT_TITLE
                }
            })
        })
        return router
    }
}
